"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = ({ typography, palette }) => ({
    tooltip: {
        fontSize: typography.caption.fontSize,
        background: palette.surface.tooltip,
        color: palette.text.inverse,
    },
});
exports.styles = styles;
